import { z } from "zod";
import { ButtonVariant } from "../ButtonVariant.js";
import { nonEmptyString } from "../zod/nonEmptyString.js";
import { urlSchema } from "../zod/urlSchema.js";

export const linkBlockSchema = z.object({
	variant: z.nativeEnum(ButtonVariant),
	text: nonEmptyString,
	url: urlSchema,
});
